<template>
  <div class="w-full p-6 space-y-10">
    <div class="w-full border rounded-lg p-6 border-slate-200 bg-white">
      <div class="flex w-full gap-8 pb-6">
        <div class="w-1/4 space-y-1">
          <h3 class="font-semibold text-lg text-dark-neutral-500">Specify the objective</h3>
          <p class="text-sm text-gray-500 font-normal">
            Summarize the overall goal of this systematic review.
          </p>
        </div>
        <div class="w-full">
          <PlanLockGuard>
            <TextInput
              ref="scopeSummary"
              v-model="summary"
              :placeholder="`Summarize the objective`"
              type="text"
              :multiline="true"
              :can-resize="true"
              input-classes="w-full pl-5 py-5  min-h-[200px] text-sm  hover:border-mid-neutral-50 focus:border-mid-neutral-50 "
              :disabled="review.isPlanReadonly.value"
              @enter="(v) => updateSynthesisPlanSummary(v)"
              @blur="(v) => updateSynthesisPlanSummary(v)"
            />
          </PlanLockGuard>
        </div>
      </div>
      <AttributesStructureBuilder />
    </div>
  </div>
</template>

<script setup lang="ts">
import { injectStrict } from "@app/utils/injectStrict";
import { ReviewKey } from "@app/views/Review/use-review";

import TextInput from "@app/components/Global/Inputs/TextInput.vue";
import AttributesStructureBuilder from "./AttributeStructureBuilder/AttributesStructureBuilder.vue";
import PlanLockGuard from "../PlanLockGuard.vue";
import { ref } from "vue";
import useSnackbar from "@app/composables/use-snackbar";
import useLoading from "@app/composables/use-loading";
import { SnackbarState } from "@app/types";
import { HttpException } from "@core/exceptions/http.exception";
import { errorMessage } from "@app/utils/error-message";
const snackbar = useSnackbar();
const loading = useLoading();
const review = injectStrict(ReviewKey);
const summary = ref(review.entity.value.plan?.synthesisPlan.summary);

async function updateSynthesisPlanSummary(newSummary: string) {
  try {
    loading.start();
    await review.updateSynthesisPlanSummary(newSummary);

    snackbar.success("Success");
  } catch (e) {
    const error = e as HttpException;
    snackbar.show(SnackbarState.ERROR, errorMessage(error.response.data));
    if (error.response.data.statusCode >= 500) {
      throw e;
    }
  } finally {
    loading.stop();
  }
}
</script>
